import {createApp} from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';
import animated from 'animate.css';


const app = createApp(App).use(store).use(router).use(Antd).use(animated);

app.mount('#app');
